import { POPOVER_RIGHT_START } from "designSystem/styles/popover-positions";
import { Box, Button, InfoPopover } from "designSystem/index";
import React, { MouseEventHandler } from "react";

export default () => {
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick: MouseEventHandler = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = !!anchorEl;
	return (
		<Box textAlign="left">
			<Button design="primary" onClick={handleClick}>
				Open Popover
			</Button>
			<InfoPopover
				anchorEl={anchorEl}
				onClose={handleClose}
				open={open}
				res="InfoMessage"
				{...POPOVER_RIGHT_START}
			/>
		</Box>
	);
};
